import { useLocation, useNavigate } from 'react-router-dom';
import { USER_TYPES, NAVIGATION_CONFIG } from '../HeaderConstants';

export const useHeaderNavigation = (userType) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get navigation items for current user type
  const getNavigationItems = () => {
    // Check practice admin types
    if (userType === USER_TYPES.PRACTICE_ADMIN || userType === USER_TYPES.PRACTICE) {
      return NAVIGATION_CONFIG[USER_TYPES.PRACTICE];
    }
    return NAVIGATION_CONFIG[userType] || [];
  };

  // Check if navigation item is active
  const isNavigationActive = (path) => {
    // For Practice Admin, User Management should be active by default or when on user management pages
    if (path === '/appointments') {
      return location.pathname === '/appointments' || 
             location.pathname === '/' || 
             location.pathname === '/staff' ||
             location.pathname.includes('/appointments');
    }
    
    // For User Management path
    if (path === '/viewUsers') {
      return location.pathname === '/viewUsers' || 
             location.pathname.includes('/viewUsers');
    }
    
    return location.pathname === path;
  };

  // Handle navigation
  const handleNavigation = (path) => {
    navigate(path);
  };

  return {
    navigationItems: getNavigationItems(),
    isNavigationActive,
    handleNavigation
  };
};
